import { Directive, Input, TemplateRef, ViewContainerRef, Injector, ChangeDetectorRef } from '@angular/core';
import { Constant } from '../pages/general/blog/constant';
import { StateService } from './state.service';


@Directive({
    standalone: true,
    selector: '[languageCheck]'
})
export class LanguageDirective {
    private language: any;
    constructor(
        private cdf: ChangeDetectorRef,
        private stateService: StateService,
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef) { 
        
    }

    @Input()
    set languageCheck(value: string) {
        this.language = value;
        if (typeof window === 'undefined') {
            return;
        }
        this.updateView();
        // Get notified each time authentication state changes.
        StateService.getLanguageState().subscribe((identity: any) => this.updateView());
    }

    private updateView(): void {
        let lang: any = 'vi';
        if (typeof window !== 'undefined') {
            lang = localStorage.getItem(Constant.key_local_language) || '';
        } 
        let result = this.language === lang.toUpperCase() ? true : false;
        this.viewContainerRef.clear();
        if (result) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
            this.cdf.detectChanges();
        }
    }
}
